import { useContext } from 'react';
import { CreateMediaModalContext } from '../context/CreateMediaModalProvider';

export const useCreateMediaModal = () => {
  const context = useContext(CreateMediaModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
